/* GENKIDAMA PREIS LIVE (05.08., Boss) - Artikelseite, REINE ANZEIGE.
 *
 * Unter dem Mengenfeld laeuft der Gesamtpreis live mit (Menge x Preis).
 * Traegt der Artikel die Koppel-Regel (gruener Release-Gruppen-Kasten),
 * zeigt eine Ampel sofort, ob die gewaehlte Menge die 150-EUR-Grenze
 * erreicht - denn EIN Artikel, dessen Gruppe allein ueber 150 EUR kommt,
 * ist frei mischbar, egal ob Release-Gruppe oder Lager.
 *
 * WICHTIG: Diese Datei BLOCKIERT NICHTS. Kein Eingriff in Warenkorb-Knopf,
 * Formular oder Menge - gesperrt wird ausschliesslich im Warenkorb
 * (genkidama-cart-max.js). FAIL-OPEN: bei jedem Fehler passiert nichts.
 */
(function () {
  'use strict';
  if (window.__genkidamaPreisLiveLoaded) return;
  window.__genkidamaPreisLiveLoaded = true;

  var MINDESTWERT_CENT = 15000; // 150 EUR
  var produkt = null;
  var hatKoppelRegel = false;

  function produktHandle() {
    var m = /\/products\/([^\/?#]+)/.exec(String(location.pathname || ''));
    return m ? m[1] : '';
  }

  function produktFormular() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function mengenFeld() {
    var f = produktFormular();
    var scope = f && f.querySelector('input[name="quantity"]') ? f : document;
    return scope.querySelector('input[name="quantity"]');
  }

  function varianteId() {
    var f = produktFormular();
    var node = (f && f.querySelector('input[name="id"], select[name="id"]')) || document.querySelector('input[name="id"], select[name="id"]');
    return node ? String(node.value || '') : '';
  }

  function euro(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function anzeigeBox() {
    var feld = mengenFeld();
    if (!feld) return null;
    var wirt = feld.closest('quantity-input') || feld.parentElement;
    if (!wirt) return null;
    var ziel = wirt.parentElement || wirt;
    var box = document.getElementById('genkidama-preis-live');
    if (!box) {
      box = document.createElement('div');
      box.id = 'genkidama-preis-live';
      box.setAttribute('style', 'margin:8px 0 4px;font-size:1.4rem;line-height:1.5;');
      ziel.appendChild(box);
    }
    return box;
  }

  function render() {
    try {
      var feld = mengenFeld();
      var box = anzeigeBox();
      if (!feld || !box || !produkt) return;
      var qty = parseInt(String(feld.value || '1'), 10) || 1;
      var vid = varianteId();
      var cent = 0;
      if (produkt.variants) {
        for (var i = 0; i < produkt.variants.length; i++) {
          if (String(produkt.variants[i].id) === vid) { cent = produkt.variants[i].price; break; }
        }
        if (!cent && produkt.variants.length) cent = produkt.variants[0].price;
      }
      if (!cent) { box.textContent = ''; return; }
      var gesamt = cent * qty;
      var html = '<span class="gk-total-label">Gesamt</span> <b class="gk-total-value">' + euro(gesamt) + '</b><span class="gk-total-unit">' + qty + ' × ' + euro(cent) + '</span>';
      if (hatKoppelRegel) {
        if (gesamt >= MINDESTWERT_CENT) {
          html += '<br><span style="color:#0c7a43;font-weight:700;">✓ Ueber 150 EUR - frei mit anderen Paketgruppen kombinierbar</span>';
        } else {
          var fehlt = MINDESTWERT_CENT - gesamt;
          html += '<br><span style="color:#d92d20;font-weight:700;">Unter 150 EUR - beim Mischen im Warenkorb auf 150 EUR auffuellen oder dort direkt unter dem Paket den Button Extra-Versand hinzufuegen nutzen (es fehlen ' + euro(fehlt) + ')</span>';
        }
      }
      box.innerHTML = html;
    } catch (e) { /* fail-open */ }
  }

  function start() {
    try {
      var handle = produktHandle();
      if (!handle || !mengenFeld()) return;
      // Ampel nur, wenn der Artikel wirklich die Koppel-Regel traegt
      // (gruener Kasten auf der Seite).
      try {
        var text = (document.body.innerText || '');
        hatKoppelRegel = /RELEASE-GRUPPE|mindestens 150|Koppel-Regel/i.test(text);
      } catch (e) { hatKoppelRegel = false; }
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { produkt = p; render(); })
        .catch(function () { /* fail-open */ });
      document.addEventListener('input', function (ev) {
        if (ev.target && (ev.target.name === 'quantity' || ev.target.name === 'id')) render();
      });
      document.addEventListener('change', function (ev) {
        if (ev.target && (ev.target.name === 'quantity' || ev.target.name === 'id')) render();
      });
      // Plus/Minus-Knoepfe und Varianten-Wechsel rendern die Menge teils neu.
      setInterval(render, 1000);
    } catch (e) { /* fail-open */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
